<script>
    import SubPageHeader from '../components/SubPageHeader.svelte'
    import WaitingPlaceholderBox from '../components/WaitingPlaceholderBox.svelte'
    import WaitingPlaceholderText from '../components/WaitingPlaceholderText.svelte'
    import PartnerLogos from '../components/PartnerLogos.svelte'

    import { onMount } from 'svelte';
    import { translations, current_lang } from '../stores.js';

    let page_content = "";
    let content_id = null;
    let get_content = null;
    let logogroups = null;

    import {REST_getPageWithSlugAndLang} from '../wp-api/api.js';

    async function getPage() {
		const page = await REST_getPageWithSlugAndLang("kumppanit","fi");

        for(let i = 0; i < page.acf.logoGroups.length; i++){
            let logogroup = page.acf.logoGroups[i];

            logogroup.plainname = logogroup.name;

            for(let k = 0; k < logogroup.logos.length; k++){
                let logo = logogroup.logos[k];
                //mediaIds.push(logo.logo);

                let w = logo.logoSize.logoWidth;
                let h = logo.logoSize.logoWidth;

                if(w != ''){
                    logo.sizeStyle = "width: "+w+"px; height: auto;"
                }else if(h != ''){
                    logo.sizeStyle = "width: auto; height: "+h+";"
                }

                logo.mediaUrl = logo.logo.sizes.medium_large;

                logogroup.logos[k] = logo;

                if(logogroup.name == "Pääyhteistyökumppanit"){
                    logogroup.name = "Pääyhteistyö&shy;kumppanit"
                }

                if(logogroup.name == "Yhteistyökumppanit"){
                    logogroup.name = "Yhteistyö&shy;kumppanit"
                }

                if(logogroup.name == "Mediakumppanit"){
                    logogroup.name = "Media&shy;kumppanit"
                }
            }
        }


		logogroups = page.acf.logoGroups;
        return true;
	}

	onMount(async () => {
        if($current_lang == "FI"){
            content_id = 13;
        }
        if($current_lang == "EN"){
            content_id = 26;
        }

        get_content = getPage();
	});
</script>

<SubPageHeader page_title={$translations["PARTNERS"][$current_lang]} />

<div class="content-container">
    {#await get_content}
        <WaitingPlaceholderText text_lines={1} />
        <WaitingPlaceholderBox box_amount={2} />

        <WaitingPlaceholderText text_lines={1} />
        <WaitingPlaceholderBox box_amount={2} />
    {:then foo}
        {#if logogroups != null}
            <PartnerLogos lang={$current_lang} logos={logogroups} />
        {/if}
    {:catch error}
        {#if $current_lang == "FI"}
            <p>Sisällön lataaminen ei onnistunut. Ongelma voi johtua siitä, että laitteesi ei saa yhteyttä verkkoon.</p>
        {:else}
            <p>Could not load content. Your device may be offline.</p>
        {/if}
    {/await}
</div>
<style>

</style>